import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import UserSearch from './search/UserSearch'
import User from './User'

export default class UserManager extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
  }

  render = () => {
    const { match } = this.props

    return (
      <ErrorBoundary>
        <Switch>
          <Route component={User} path={`${match.path}/:email/:id`} />
          <Route component={UserSearch} path={match.path} />
        </Switch>
      </ErrorBoundary>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/css-admin/users/UserManager.js